import { ActionReducerMap } from "@ngrx/store";
import { NavigationEffects } from "./common/navigation/navigation.effects";
import { LocalStorageEffects } from "./common/local-storage/local-storage.effects";
import { ToastMessageEffects } from "./common/toast-message/toast.message.effects";
import { navigationReducer } from "./common/navigation/navigation.reducer";
import { GeneralDataEffects } from "./general-data/general-data.effects";

export const appEffects: any[] = [
    NavigationEffects,
    ToastMessageEffects,
    LocalStorageEffects,
    GeneralDataEffects
];

export const appReducers: ActionReducerMap<any, any> = {
    navigation: navigationReducer,
};